import {StatesItemType} from 'types/locationType';

/**
 * Transform backend response to frontend format
 */
export const transformBackendRegions = (
    states: {code: string; id: string; name: string}[],
): StatesItemType[] =>
    states.length
        ? states.map(({code, id, name}) => ({
              id: String(id),
              label: name,
              value: String(code),
          }))
        : [];
